
//import {SmetioAjax} from 
  //  "./../../classes/smetioAjax/SmetioAjax.js";

import {globalVar} from 
    "./../../variables/global_variables.js";

export function getDataInChunks(setupObj){


/*

	THE smetioAjax NEEDS TO BE PASSED TO THIS FUNCTION IN ORDER TO ALLOW MORE FLEXIBILITY
	SO FOR EXAMPLE OTHER ACTIONS CAN BE PERFORMED BEFORE THE AJAX IS CALLED AND WHEN THE 
	AJAX SUCCEEDS OF AN ERROR OCCURED

    const setupObj = {
    	
    	smetioAjax: smetioAjax
        url_of_totalNumber: "https://smetio.com/retrieveData/totalNumbersOfworldLanguages/",
        url_of_data: "https://smetio.com/retrieveData/worldLanguages/",
        offsetVariable: globalVar.worldLanguagesSelectionOffset,
        loadedCheckVariable: globalVar.worldLanguageIsBeingLoaded,
        totalNumberVariable: globalVar.totalNumbersOfWorldLanguages,
        dataToRetreive: "language",
        chunkFunction: chunk_is_loaded,
        allDataRetrievedFunction: all_world_language_is_selected,
        errorExtraText: "Try again by clicking on the language tab",
        errorContainer: "#smetio-app-ui-region-and-languages-content-languages",
    
    };    
    
*/   
    
        
    /**** 
    
        FIRST GET THE TOTAL NUMBER OF DATA TO BE SELECTED
        
        THIS WILL BE  USED TO TELL WHEN THE TOTAL DATA HAS BEEN RETRIEVED 

        USE THE dataToSendToServer TO TELL THE SERVER THE LIMIT AND OFFSET OF THE SELECTION
    
    ****/

    let smetioAjax = setupObj.smetioAjax;
    
    smetioAjax.dataToSendToServer["limit"] = globalVar.chunkDataRetrievalSize;
    smetioAjax.dataToSendToServer["offset"] = setupObj.offsetVariable;
    
    smetioAjax.urlToConnectTo = setupObj.url_of_totalNumber;
    
    if(setupObj.totalNumberVariable != 0){

        /**** 
        
            THIS MEANS THE FUNCTION HAD BEEN CALLED BEFORE, BUT THEN AN ERROR OCCURED
            BEFORE THE ENTIRE DATA COULD BE LOADED
        
        ****/
    
        smetioAjax.urlToConnectTo = setupObj.url_of_data;
        
        smetioAjax.dataType = "json";
            
    };
        
    
    smetioAjax.beforeSend = () => {

		//smetioAjax.beforeSend();

        $(setupObj.errorContainer+" .ajaxErrorMsg").remove();
        
        setupObj.loadedCheckVariable = true;
        
    };
    
    
    smetioAjax.success = (result) => {
        
    	//smetioAjax.success();

        if(smetioAjax.urlToConnectTo === setupObj.url_of_totalNumber ){
        
            setupObj.totalNumberVariable = result;            
            
            smetioAjax.urlToConnectTo = setupObj.url_of_data;
            
            smetioAjax.dataType = "json";
            
            smetioAjax.sendRequest();
        
        }else{
        
            if(setupObj.offsetVariable <= setupObj.totalNumberVariable){
               
                setupObj.chunkFunction(result);
                                            
                setupObj.offsetVariable += globalVar.chunkDataRetrievalSize;
                
                smetioAjax.dataToSendToServer.offset = setupObj.offsetVariable;
                
                smetioAjax.sendRequest();
                
            }else{

                setupObj.allDataRetrievedFunction(result);
                
                smetioAjax = null;

                return true;
            };        
        
        };
                        
    };    


    smetioAjax.error = (request, status, error) => {

    	//smetioAjax.error();

        setupObj.loadedCheckVariable = false;
        
        smetioAjax.defaultErrorMsg +=`<h5>${ setupObj.errorExtraText } </h5>`;
        
        smetioAjax.showErrorMessage(setupObj.errorContainer);
                
		smetioAjax = null;

        return false;
            
    };
    
    smetioAjax.sendRequest();
    
};
